module.exports = __webpack_public_path__ + "img/part1-icon.8da67674.png";